import ActStatusCircle from "../../../UIElements/StatusCircle";
import EnumsContext from "../../../../context/enums-context";
import { formatCurrency, useEnumLabel } from "../../../../Utils/Utils";
import useApi from "../../../../Utils/BackendClient";
import { useContext, useEffect, useMemo, useRef, useState } from "react";
import useGetEnums from "../../../../Utils/EnumsUtils";
import { useLocation, useNavigate } from "react-router-dom";
import { useIsMobile } from "../../../../Utils/ResizeUtils";

import { Button } from "primereact/button";
import { Chip } from "primereact/chip";
import { Column } from "primereact/column";
import { confirmDialog, ConfirmDialog } from "primereact/confirmdialog";
import { DataTable } from "primereact/datatable";
import { SplitButton } from "primereact/splitbutton";
import { Toast } from "primereact/toast";
import { Toolbar } from "primereact/toolbar";

import commonStyle from "../../CommonStyles.module.css";
import PaymentSideBar from "../../../UIElements/Sidebars/PaymentSidebar";
import DocumentPrintSidebar from "../../../UIElements/DocumentPrintSidebar";
import DocumentArchive from "../../../UIElements/DocumentArchive";
import DropDownTemplate from "../../../UIElements/FilterTemplates/DropDownTemplate";

const DistributorReturns = () => {

    const buttonRef = useRef(null);
    const ctx = useContext(EnumsContext);
    const isMobile = useIsMobile();
    const location = useLocation();
    const navigate = useNavigate();
    const toast = useRef(null);

    const { deleteDistributorReturnAct, fetchDistributorReturnActs, fetchDistributorReturnActDocuments, finalizeDistributorReturnAct } = useApi();

    const statuses = {
        "PENDING": "Драфт",
        "FINALIZED": "Фіналізований"
    }

    const [acts, setActs] = useState([]);
    const [docArchive, setDocArchive] = useState(null);
    const [docArchiveSidebarVisible, setDocArchiveSidebarVisible] = useState(false);
    const [docArchiveTotalRecords, setDocArchiveTotalRecords] = useState(0);
    const [docPrintSidebarVisible, setDocPrintSidebarVisible] = useState(false);
    const [loading, setLoading] = useState(true);
    const [reloadData, setReloadData] = useState(true);
    const [selectedItem, setSelectedItem] = useState(null);
    const [totalRecords, setTotalRecords] = useState(0);
    const [visible, setVisible] = useState(false);
    const [tableFilters, setTableFilters] = useState({
        cagent: { value: null, matchMode: 'equals' },
        status: { value: null, matchMode: 'equals' },
        pay_status: { value: null, matchMode: 'equals' },
        division: { value: null, matchMode: 'equals' },
    });
    const [lazyState, setlazyState] = useState({
        first: 0,
        rows: 10,
        page: 1,
        sortField: "created_at",
        sortOrder: 1,
        filters: {
            cagent: { value: null, matchMode: 'equals' },
            status: { value: null, matchMode: 'equals' },
            pay_status: { value: null, matchMode: 'equals' },
            division: { value: null, matchMode: 'equals' },
        }
    });
    const [docArchiveLazyState, setDocArchiveLazyState] = useState({
        first: 0,
        rows: 10,
        page: 1
    });

    const enumTypes = useMemo(() => ["divisions", "partners", "pay_statuses"], []);

    useGetEnums(enumTypes);

    const getDivisionLabel = useEnumLabel(ctx.enums.divisions.data);
    const getPartnerLabel = useEnumLabel(ctx.enums.partners.data);
    const getPayStatusLabel = useEnumLabel(ctx.enums.pay_statuses.data);

    const showToast = (msg) => {
        toast.current.show(msg);
    }

    useEffect(() => {
        if(location.state?.toast){
            showToast(location.state.toast);

            location.state.toast = null;
            navigate(location.pathname, { replace: true, state: location.state});
        }

    }, [location, navigate]);

    useEffect(() => {
        const fetchData = async () => {

            let state = lazyState;

            if(location.state?.pageState){

                state = location.state?.pageState;
                setlazyState(location.state?.pageState);

                location.state.pageState = null;

                navigate(location.pathname, { replace: true, state: location.state });
            }

            const response = await fetchDistributorReturnActs(state);

            console.log(response);

            if (response.status === 200) {

                setTotalRecords(response.data.count);
                setActs(response.data.results);

            }
            else {
                setActs([]);
                toast.current.show({ severity: "error", summary: "Помилка завантаження списку актів", detail: "Помилка сервера " + response.status, life: 3000 });
            }
            setLoading(false);
        }

        fetchData();

    }, [fetchDistributorReturnActs, lazyState, location, navigate, reloadData]);

    const hideSidebar = () => {
        setVisible(false);
    };

    const onPage = (event) => {
        event.page = event.page + 1;
        setlazyState(event);
    };

    const onSort = (event) => {
        event.page = lazyState.page;
        setlazyState(event);
    }

    const onFilter = (event) => {
        setTableFilters(event.filters);
    }

    const onDocArchivePage = (event) => {
        event.page = event.page + 1;
        getDocumentsArchive(selectedItem, event);

        setDocArchiveLazyState(event);
    } 

    const CreateNewSaleButtonHandler = () => {
        navigate("/distributorreturns/newreturn");
    }

    const DeleteButtonHandler = rowData => {
        const deleteAct = async () => {

            const response = await deleteDistributorReturnAct(rowData.id);

            if (response.status !== 204) {
                toast.current.show({ severity: "error", summary: "Помилка видалення", detail: "Помилка сервера " + response.status, life: 3000 });
            }
            else {
                toast.current.show({ severity: "success", summary: 'Видалення', detail: 'Акт успішно видалено', life: 3000 });
            }
            setReloadData(!reloadData);
        }

        deleteAct();
    }

    const FinalizeActHandler = (rowData) => {

        const finalizeAct = async () => {

            const response = await finalizeDistributorReturnAct(rowData.id);

            if (response.status !== 200) {
                toast.current.show({ severity: "error", summary: "Помилка фіналізації", detail: "Помилка сервера " + response.status, life: 3000 });
            }
            else {
                toast.current.show({ severity: 'success', summary: 'Фіналізація', detail: 'Акт фіналізовано', life: 3000 });
            }

            setReloadData(!reloadData);
        }

        finalizeAct();
    }

    const PaymenButtonHandler = (rowData) => {

        setSelectedItem(rowData);
        setVisible(true);
    }

    const EditProductHandler = (rowData) => {
        const route = '/distributorreturns/editreturn/' + rowData.id;
        navigate(route, { state: { id: rowData.id, pageState: lazyState } });
    }

    const confirmDelete = (rowData) => {
        confirmDialog({
            group: 'headless',
            header: 'Підтвердження',
            message: 'Підтвердіть видалення акту',
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: "Так",
            rejectLabel: "Hi",
            defaultFocus: 'accept',
            accept: () => { DeleteButtonHandler(rowData) }
        });
    }

    const confirmFinalize = (event, rowData) => {
        confirmDialog({
            group: 'headless',
            header: 'Підтвердження',
            message: 'Після фіналізації акту, буде відсутня можливість його редагування',
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: "Так",
            rejectLabel: "Hi",
            defaultFocus: 'accept',
            accept: () => { FinalizeActHandler(rowData) }
        });
    }

    const formatFilterChips = () => {
        const element = [];

        Object.keys(lazyState.filters).forEach((filterKey) => {
            const filter = lazyState.filters[filterKey];

            if (filter.value && filter.value !== "") {

                let translatedKey = filterKey;
                let changedValue = filter.value;
                let removeValue = null;


                if (filterKey === "pay_status") {
                    translatedKey = "Статус оплати";
                    changedValue = getPayStatusLabel(changedValue);
                    removeValue = "";
                }
                else if (filterKey === "status") {
                    translatedKey = "Статус акту";
                    changedValue = statuses[changedValue];
                    removeValue = "";
                }
                else if (filterKey === "cagent") {
                    translatedKey = "Постачальник";
                    changedValue = getPartnerLabel(changedValue);
                    removeValue = "";
                }
                else if (filterKey === "division") {
                    translatedKey = "Точка продажу";
                    changedValue = getDivisionLabel(changedValue);
                    removeValue = "";
                }

                element.push(
                    <Chip
                        key={filterKey}
                        label={`${translatedKey}: ${changedValue}`}
                        removable
                        onRemove={() => clearFilterFromChips(filterKey, removeValue)} // Optional: To handle removal
                    />
                );
            }
        });

        return <div className="flex flex-wrap gap-2">{element}</div>;
    }

    const formatAdditionalButtons = (rowData) => {
        let buttons = [];
        if (rowData.status !== "FINALIZED") {
            buttons.push({
                label: 'Фіналізувати',
                icon: 'pi pi-lock',
                command: (event) => { confirmFinalize(event, rowData) }
            });
        }
        else {
            if (rowData.pay_status !== "PAYED") {
                buttons.push({
                    label: 'Оплатити',
                    icon: 'pi pi-money-bill',
                    command: () => { PaymenButtonHandler(rowData) }
                });
            }
        }

        if (rowData.can_be_deleted) {
            buttons.push({
                label: 'Видалити',
                icon: 'pi pi-trash',
                command: () => { confirmDelete(rowData) }
            });
        }

        if (rowData.templates?.length > 0) {
            buttons.push({
            label: 'Друкувати документи',
            icon: 'pi pi-print',
            command: () => {
                setDocPrintSidebarVisible(true)
                setSelectedItem(rowData);
            }
        })};

        buttons.push({
            label: 'Архів документів',
            icon: 'pi pi-save',
            command: () => {
                getDocumentsArchive(rowData, docArchiveLazyState);
                setDocArchiveSidebarVisible(true)
        }});

        buttons = buttons.length > 0 ? buttons : null;
        return buttons
    };

    const filterApply = () => {
        const editedLazyState = lazyState;
        editedLazyState.page = 1;
        editedLazyState.filters = tableFilters;
        setlazyState(editedLazyState);
        setReloadData(!reloadData);
    }

    const clearFilter = (paramName, value) => {
        setlazyState(prevState => ({
            ...prevState,
            filters: {
                ...prevState.filters,
                [paramName]: {
                    ...prevState.filters[paramName],
                    value: value
                }
            }
        }));
    }

    const clearFilterFromChips = (paramName, value) => {
        clearFilter(paramName, value);
        setTableFilters(prevState => ({
            ...prevState,
            [paramName]: {
                value: value
            }
        }));
    }

    const getDocumentsArchive = async (data, lazyState) => {

        setSelectedItem(data);

        const response = await fetchDistributorReturnActDocuments(data.id, lazyState);

        if(response.status === 200){
            setDocArchive(response.data.results);
            setDocArchiveTotalRecords(response.data.count);
        }
    }

    const resetLazyState = () => {
        setDocArchiveLazyState({
            first: 0,
            rows: 10,
            page: 1
        })
    }

    const tableHeader = (
        <div className="flex justify-content-between align-items-center w-full">
            {formatFilterChips()}
        </div>
    );

    const toolbarRightTemplate = () => {
        return (<div className="flex flex-wrap gap-2">
            <Button label="Створити акт" severity="success" className={commonStyle.addButton} onClick={CreateNewSaleButtonHandler} />
        </div>)
    }

    const actionBodyTemplate = (rowData) => {
        const buttons = formatAdditionalButtons(rowData);

        const buttonLabel = rowData.status !== "FINALIZED" ? "Редагувати" : "Деталі акту";
        const buttonIcon = rowData.status !== "FINALIZED" ? "pi pi-pencil" : "pi pi-eye";

        return (
            <SplitButton
                label={!isMobile ? buttonLabel : null}
                icon={buttonIcon}
                onClick={() => EditProductHandler(rowData)}
                model={buttons}
                text
                ref={buttonRef} // Set the ref here
            />
        );
    }

    const mobileActBody = rowData => {

        const color = rowData.pay_status === "PAYED" ? "#03C04A" : "#EF4444";

        return (
            <div className="flex justify-content-between flex-wrap">
                <div className="grid w-8">
                    <div className="col-2 flex justify-content-center align-items-center">
                        <ActStatusCircle rowData={rowData} />
                    </div>
                    <div className="col-10">
                        <div className="flex-column">
                            <div>Акт №{rowData.act_number}</div>
                            <div><i className="pi pi-clock"/> {rowData.act_date}</div>
                            <div style={{ color }}><i className={`pi ${rowData.pay_status === "PAYED" ? "pi-check" : "pi-times"}`}/> {getPayStatusLabel(rowData.pay_status)}</div>
                            <div><i className="pi pi-user"/> {getPartnerLabel(rowData.cagent) ?? "Клієнта не вказано"}</div>
                            <div><i className="pi pi-money-bill"/> {formatCurrency(rowData.amountUAH, "UAH")}</div>
                        </div>
                    </div>
                </div>
                <div className="flex justify-content-center align-items-center">
                    {actionBodyTemplate(rowData)}
                </div>
            </div>
        )
    }

    return (<>
        <Toast ref={toast} />
        <Toolbar className="mb-4" end={toolbarRightTemplate} />
        <div className='grid'>
            <div className='col-12 justify-content-center'>
            {!isMobile && <DataTable value={acts} header={tableHeader} stripedRows lazy rows={lazyState.rows} paginator onPage={onPage} onSort={onSort} sortField={lazyState.sortField} sortOrder={lazyState.sortOrder}
                    first={lazyState.first} loading={loading} totalRecords={totalRecords} rowsPerPageOptions={[10, 20, 50]}
                    onFilter={onFilter} filters={tableFilters}>
                    <Column field="act_number" header="Номер акту" sortable style={{ width: '10%' }} />
                    <Column field="act_date" dataType="date" header="Дата акту" sortable style={{ width: '10%' }} />
                    <Column field="cagent" header="Контрагент" sortable filter filterElement={(options) => DropDownTemplate(options, ctx.enums.partners.data)} onFilterApplyClick={filterApply}
                        onFilterClear={() => clearFilter("cagent", null)} showFilterMatchModes={false} body={rowData => getPartnerLabel(rowData.cagent)} style={{ width: '19%' }} />
                    <Column field="division" header="Точка продажу" sortable filter filterElement={(options) => DropDownTemplate(options, ctx.enums.divisions.data)} onFilterApplyClick={filterApply}
                        onFilterClear={() => clearFilter("division", null)} showFilterMatchModes={false} body={rowData => getDivisionLabel(rowData.division)} style={{ width: '10%' }} />
                    <Column field="amountUAH" header="Сума акту, грн" body={rowData => formatCurrency(rowData.amountUAH, "UAH")} style={{ width: '10%' }} />
                    <Column field="pay_status" header="Статус оплати" filter filterElement={(options) => DropDownTemplate(options, ctx.enums.pay_statuses.data)} onFilterApplyClick={filterApply}
                        onFilterClear={() => clearFilter("pay_status", null)} showFilterMatchModes={false} body={rowData => getPayStatusLabel(rowData.pay_status)} style={{ width: '10%' }} />
                    <Column field="pay_due_date" header="Дата оплати" />
                    <Column field="status" header="Статус" sortable filter filterElement={(options) => DropDownTemplate(options, statuses)} onFilterApplyClick={filterApply}
                        onFilterClear={() => clearFilter("status", null)} showFilterMatchModes={false} body={rowData => <ActStatusCircle rowData={rowData} />} style={{ width: '6%' }} />
                    <Column field="action" body={actionBodyTemplate} style={{ width: '15%' }} />
                </DataTable>}
                {isMobile && <DataTable value={acts} header={tableHeader} stripedRows lazy rows={lazyState.rows} paginator onPage={onPage} onSort={onSort} sortField={lazyState.sortField} sortOrder={lazyState.sortOrder}
                    first={lazyState.first} loading={loading} totalRecords={totalRecords} rowsPerPageOptions={[10, 20, 50]} paginatorTemplate="FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink RowsPerPageDropdown"
                    dataKey="id" onFilter={onFilter} filters={lazyState.filters} emptyMessage="Актів не знайдено" >
                    <Column field="act_number" headerStyle={{ display: 'none' }} body={mobileActBody} />
                </DataTable>} 
            </div>
            <ConfirmDialog group="headless" />
        </div>
        <PaymentSideBar visible={visible} onHide={hideSidebar} onMessage={showToast} data={selectedItem} moneyMovementType="INCOME" reloadData={() => setReloadData(!reloadData)}/>
        <DocumentPrintSidebar sbVisible={docPrintSidebarVisible} onHide={() => setDocPrintSidebarVisible(false)} actData={selectedItem} toast={toast}/>
        <DocumentArchive sbVisible={docArchiveSidebarVisible} onHide={() => {setDocArchiveSidebarVisible(false); resetLazyState();}} 
                        documents={docArchive} lazyState={docArchiveLazyState} onPage={onDocArchivePage} totalRecords={docArchiveTotalRecords} toast={toast}/>
    </>
    );
};

export default DistributorReturns;